import React from "react";
import { Wifi, Tv, Wind, Coffee, Refrigerator, Waves, Dumbbell, Car, Bed, Bath, Users, Ruler, Fan, Utensils, Toilet, WashingMachine, Building2 } from "lucide-react";

export const AMENITY_ICONS = {
  Wifi: { Icon: Wifi, label: "Wifi ready" },
  Tv: { Icon: Tv, label: "Smart TV with Netflix" },
  AirVent: { Icon: Wind, label: "Airconditioned bedroom" },
  Kitchen: { Icon: Utensils, label: "Kitchen" },
  Toilet: { Icon: Toilet, label: "Toilet" },
  WashingMachine: { Icon: WashingMachine, label: "Automatic Washing Machine" },
  PoolBalcony: { Icon: Waves, label: "Pool View Balcony" },
  CityBalcony: { Icon: Building2, label: "City View Balcony" },
  CeilingFan: { Icon: Fan, label: "Ceiling fan" },
  Coffee: { Icon: Coffee, label: "Kitchen & utensils" },
  Refrigerator: { Icon: Refrigerator, label: "Refrigerator" },
  Pool: { Icon: Waves, label: "Pool Access" },
  Gym: { Icon: Dumbbell, label: "Gym" },
  Parking: { Icon: Car, label: "Parking" },
};

export function Amenity({ k }) {
  const a = AMENITY_ICONS[k];
  if (!a) return null;
  const { Icon, label } = a;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-neutral-600">
      <Icon className="h-3.5 w-3.5 text-[var(--xs-primary)]" /> {label}
    </span>
  );
}

export function StatPill({ Icon, label }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-neutral-700 bg-[var(--xs-bg-alt)] rounded-full px-2.5 py-1">
      <Icon className="h-3.5 w-3.5" /> {label}
    </span>
  );
}

export function UnitMeta({ unit }) {
  const paxLabel = unit.pax_label || `${unit.guests} guests`;
  return (
    <div className="flex flex-wrap gap-1.5">
      <StatPill Icon={Users} label={paxLabel} />
      {unit.type && <StatPill Icon={Bed} label={unit.type} />}
    </div>
  );
}
